function gloops (state = false, action) {
	if (action.type == 'SET GLOOPS') {
		state = action.data;
	}
	if (action.type == 'UPDATE GLOOP DATA') {
		let temp = Object.assign({}, state[action.id], {data: action.data});
		state = Object.assign({}, state, {[action.id]: temp})
	}
	if (action.type == 'EDIT GLOOP') {
		let tempData =  Object.assign({}, state[action.id].data, action.data);
		let temp = Object.assign({}, state[action.id], {data : tempData});
		state = Object.assign({}, state, {[action.id]: temp})
	}
	if (action.type == 'ADD GLOOP') {
		state = Object.assign({}, state, {[action.id]: {
			id : action.id,
			status : 'loaded',
			data : action.data
		}})
	}
	return state;
}

export default gloops;